export enum NotificationStatus {
  Success = "Success",
  Failure = "Failure",
  All = "All",
  None = "None",
}
